import { Star } from "lucide-react";

export function StarRating({ rating = 0, count, size = 14, className = "" }) {
  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="star-rating">
      <div className="flex">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star key={i} size={size}
            className={i <= Math.round(rating) ? "fill-amber-400 text-amber-400" : "fill-stone-200 text-stone-200"} />
        ))}
      </div>
      {rating ? <span className="text-sm font-semibold text-stone-700">{Number(rating).toFixed(1)}</span> : null}
      {count != null ? <span className="text-xs text-stone-400">({count})</span> : null}
    </div>
  );
}

const LABEL_STYLES = {
  "New": "bg-sky-100 text-sky-700",
  "Trending": "bg-orange-100 text-[var(--friib)]",
  "Popular": "bg-violet-100 text-violet-700",
  "Almost Gone": "bg-red-100 text-red-600",
  "Ending Soon": "bg-amber-100 text-amber-700",
  "Near You": "bg-emerald-100 text-emerald-700",
  "Trending Nearby": "bg-orange-100 text-[var(--friib)]",
  "Limited": "bg-red-100 text-red-600",
  "Weekend Friib": "bg-indigo-100 text-indigo-700",
  "Today Only": "bg-amber-100 text-amber-700",
};

export function Label({ children }) {
  const cls = LABEL_STYLES[children] || "bg-stone-100 text-stone-600";
  return <span className={`px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-wide ${cls}`}>{children}</span>;
}

export function FreePill({ className = "" }) {
  return (
    <span className={`px-3 py-1 rounded-full text-sm font-extrabold text-white ${className}`}
      style={{ background: "var(--mint)" }}>FREE</span>
  );
}

export function Sponsored() {
  return <span className="px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide bg-indigo-50 text-indigo-500 border border-indigo-100">Sponsored</span>;
}
